/*
 * Tally quiz section — postMessage listeners
 * Reads configuration from the wrapper's data-* attributes.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.tallyQuizInit === '1') return;
    root.dataset.tallyQuizInit = '1';

    var allowedOrigins = (root.dataset.allowedOrigins || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
    var emailPage = parseInt(root.dataset.emailPage, 10);
    if (isNaN(emailPage)) emailPage = -1;
    var redirectUrl = root.dataset.redirectUrl || '/';
    var loaderTextSubmit = root.dataset.loaderTextSubmit || '';
    var metaPageView = root.dataset.metaPageView === 'true';
    var metaViewContentOnSubmit = root.dataset.metaViewContentOnSubmit === 'true';
    var introEnabled = root.dataset.introEnabled === 'true';
    var firedViewContentSubmissions = {};

    var loader = root.querySelector('[data-tally-loader]');
    var loaderText = root.querySelector('[data-tally-loader-text]');
    var intro = root.querySelector('[data-tally-intro]');
    var iframe = root.querySelector('[data-tally-iframe]');
    var introCta = intro && intro.querySelector('.tally-quiz__intro-cta');
    var hideTimer = null;
    var introClosed = !introEnabled || !intro;
    var iframeReady = false;
    var INTRO_FADE_MS = 350;

    function setIntroCtaState(isReady) {
      if (!introCta) return;
      if (isReady) {
        introCta.removeAttribute('disabled');
        introCta.setAttribute('aria-disabled', 'false');
        introCta.removeAttribute('tabindex');
      } else {
        introCta.setAttribute('disabled', 'disabled');
        introCta.setAttribute('aria-disabled', 'true');
        introCta.setAttribute('tabindex', '-1');
      }
    }

    function showLoader() {
      if (!loader) return;
      loader.hidden = false;
      void loader.offsetWidth;
      loader.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideLoader, 3000);
    }

    function hideLoader() {
      if (!loader) return;
      clearTimeout(hideTimer);
      loader.classList.remove('is-visible');
      var onEnd = function () {
        loader.hidden = true;
        loader.removeEventListener('transitionend', onEnd);
      };
      loader.addEventListener('transitionend', onEnd);
    }

    function finalizeIntroHidden() {
      if (!intro) return;
      intro.hidden = true;
      intro.setAttribute('aria-hidden', 'true');
    }

    function closeIntroAndRevealIframe(showLoaderWhileWaiting) {
      if (introClosed) return;
      introClosed = true;
      root.classList.remove('is-intro-active');

      if (intro) {
        intro.classList.add('is-hidden');
        intro.addEventListener('transitionend', finalizeIntroHidden, { once: true });
        setTimeout(finalizeIntroHidden, INTRO_FADE_MS + 80);
      }

      if (showLoaderWhileWaiting && !iframeReady) {
        showLoader();
      }
    }

    function markIframeReady() {
      if (iframeReady) return;
      iframeReady = true;
      setIntroCtaState(true);
      hideLoader();
    }

    function parseMessage(event) {
      if (allowedOrigins.indexOf(event.origin) === -1) return null;
      var data = event.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return null; }
      }
      if (!data || typeof data !== 'object') return null;
      return data;
    }

    function fireMetaPageView() {
      if (!metaPageView || window.__tallyQuizMetaPageViewFired || typeof window.fbq !== 'function') return;
      window.__tallyQuizMetaPageViewFired = true;
      try { window.fbq('track', 'PageView'); } catch (e) { }
    }

    function fireMetaViewContent(submissionId) {
      if (!metaViewContentOnSubmit || typeof window.fbq !== 'function') return;
      var key = submissionId || '__unknown__';
      if (firedViewContentSubmissions[key]) return;
      firedViewContentSubmissions[key] = true;
      try { window.fbq('track', 'ViewContent'); } catch (e) { }
    }

    fireMetaPageView();

    if (introCta) {
      setIntroCtaState(iframeReady);
      introCta.addEventListener('click', function (event) {
        event.preventDefault();
        closeIntroAndRevealIframe(true);
      });
    }

    if (iframe) {
      iframe.addEventListener('load', markIframeReady);
    }

    window.addEventListener('message', function (event) {
      var data = parseMessage(event);
      if (!data) return;
      markIframeReady();

      if (data.event === 'Tally.FormPageView') {
        var pageNumber = (data.payload && data.payload.page != null)
          ? data.payload.page
          : -1;
        if (pageNumber === emailPage) {
          showLoader();
          setTimeout(hideLoader, 1200);
        }
        return;
      }

      if (data.event === 'Tally.FormSubmitted') {
        if (loader && loaderText && loaderTextSubmit) {
          loaderText.textContent = loaderTextSubmit;
        }
        if (loader) {
          loader.hidden = false;
          void loader.offsetWidth;
          loader.classList.add('is-visible');
        }

        var payload = data.payload || {};
        var fields = payload.fields || [];
        var emailField = fields.find && fields.find(function (f) {
          return f.type === 'INPUT_EMAIL';
        });
        var userEmail = (emailField && emailField.answer && emailField.answer.value) || '';
        var fullId = (payload.formId || '') + '-' + (payload.id || '');

        fireMetaViewContent(fullId);

        if (window.TallyQuizStore && typeof window.TallyQuizStore.setSubmissionCookie === 'function') {
          window.TallyQuizStore.setSubmissionCookie(fullId, 30);
        }

        var savePromise = (window.TallyQuizStore && window.TallyQuizStore.save)
          ? window.TallyQuizStore.save({
            formId: payload.formId || '',
            submissionId: payload.id || '',
            fields: fields,
            email: userEmail
          })
          : Promise.resolve();

        savePromise
          .catch(function () { })
          .then(function () {
            setTimeout(function () {
              window.location.href = redirectUrl;
            }, 400);
          });
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-tally-quiz-root]').forEach(init);
    document.querySelectorAll('[data-tally-stage-root]').forEach(initStage);
    document.querySelectorAll('[data-ledisa-cover-root]').forEach(initLedisaCover);
  }

  /* ───────────────────────────────────────────────────────────
     Cover → quiz stage transition.
     On click of any [data-ledisa-goal] element inside a stage root
     with data-stage="cover", capture the goal value, append it to
     the iframe URL as ?weight_goal=..., flip stage to "quiz".
     ─────────────────────────────────────────────────────────── */
  function initStage(stageRoot) {
    if (!stageRoot || stageRoot.dataset.tallyStageInit === '1') return;
    stageRoot.dataset.tallyStageInit = '1';
    var GOAL_STORAGE_KEY = 'ledisa_quiz_weight_goal';
    var lastRevealAt = 0;

    function safeSetStoredGoal(value) {
      try { window.sessionStorage.setItem(GOAL_STORAGE_KEY, value); } catch (e) { }
    }

    function safeGetStoredGoal() {
      try { return window.sessionStorage.getItem(GOAL_STORAGE_KEY) || ''; } catch (e) { return ''; }
    }

    function resolveGoalTarget(target) {
      var host = target && target.closest ? target.closest('[data-ledisa-goal]') : null;
      if (!host || !stageRoot.contains(host)) return null;
      return host;
    }

    function revealFromTarget(target) {
      var host = resolveGoalTarget(target);
      if (!host) return;
      var now = Date.now();
      if (now - lastRevealAt < 120) return;
      lastRevealAt = now;
      var goal = host.getAttribute('data-ledisa-goal') || '';
      if (goal) {
        stageRoot.dataset.selectedGoal = goal;
        safeSetStoredGoal(goal);
      }
      revealQuiz(stageRoot, { weight_goal: goal });
    }

    stageRoot.addEventListener('click', function (event) {
      var host = resolveGoalTarget(event.target);
      if (!host) return;
      event.preventDefault();
      var radio = host.querySelector('.ledisa-choice-radio');
      if (radio) radio.checked = true;
      revealFromTarget(host);
    });

    // Some themes/extensions interfere with click bubbling on label wrappers.
    // Pointer-up capture gives us a reliable fallback to trigger the stage swap.
    stageRoot.addEventListener('pointerup', function (event) {
      var host = resolveGoalTarget(event.target);
      if (!host) return;
      var radio = host.querySelector('.ledisa-choice-radio');
      if (radio) radio.checked = true;
      revealFromTarget(host);
    }, true);

    stageRoot.addEventListener('change', function (event) {
      if (!event.target || !event.target.classList || !event.target.classList.contains('ledisa-choice-radio')) return;
      revealFromTarget(event.target);
    });

    stageRoot.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var host = resolveGoalTarget(event.target);
      if (!host) return;
      event.preventDefault();
      var radio = host.querySelector('.ledisa-choice-radio');
      if (radio) radio.checked = true;
      revealFromTarget(host);
    });

    if (stageRoot.dataset.stage === 'quiz') {
      var restoredGoal = stageRoot.dataset.selectedGoal || safeGetStoredGoal();
      revealQuiz(stageRoot, restoredGoal ? { weight_goal: restoredGoal } : {});
    }
  }

  function syncIframeQuery(iframe, extraParams) {
    if (!iframe) return;
    try {
      var url = new URL(iframe.src, window.location.href);
      var hasMutation = false;
      Object.keys(extraParams || {}).forEach(function (k) {
        var value = extraParams[k];
        if (value == null || value === '') return;
        if (url.searchParams.get(k) !== String(value)) {
          url.searchParams.set(k, value);
          hasMutation = true;
        }
      });
      var pass = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid','ttclid','msclkid'];
      var qs = new URLSearchParams(window.location.search);
      pass.forEach(function (k) {
        if (!qs.has(k)) return;
        var nextValue = qs.get(k);
        if (url.searchParams.get(k) !== nextValue) {
          url.searchParams.set(k, nextValue);
          hasMutation = true;
        }
      });
      if (hasMutation) iframe.src = url.toString();
    } catch (e) { }
  }

  function revealQuiz(stageRoot, extraParams) {
    var iframe = stageRoot.querySelector('.tally-quiz__iframe');
    syncIframeQuery(iframe, extraParams || {});

    if (stageRoot.dataset.stage === 'quiz') {
      if (iframe && typeof iframe.focus === 'function') {
        try { iframe.focus({ preventScroll: true }); } catch (e) {}
      }
      return;
    }

    stageRoot.setAttribute('data-stage', 'quiz');
    var cover = stageRoot.querySelector('[data-ledisa-cover-root]');
    if (cover && cover.parentElement) {
      // Drop banner top-padding when cover unmounts
      document.body.classList.remove('has-ledisa-cover');
    }
    if (iframe && typeof iframe.focus === 'function') {
      try { iframe.focus({ preventScroll: true }); } catch (e) {}
    }
    // Scroll back to top so the quiz starts at the iframe origin
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }

  /* ───────────────────────────────────────────────────────────
     Ledisa cover behaviour: countdown clock to midnight EDT.
     ─────────────────────────────────────────────────────────── */
  function initLedisaCover(coverRoot) {
    if (!coverRoot || coverRoot.dataset.ledisaCoverInit === '1') return;
    coverRoot.dataset.ledisaCoverInit = '1';
    document.body.classList.add('has-ledisa-cover');

    function nowEDT() {
      var opts = { timeZone: 'America/New_York', hour12: false };
      return new Date(new Date().toLocaleString('en-US', opts));
    }
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = nowEDT();
      var midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      var diff = midnight - now;
      if (diff <= 0) diff = 24 * 60 * 60 * 1000;
      var h = pad(Math.floor(diff / 3600000));
      var m = pad(Math.floor((diff % 3600000) / 60000));
      var s = pad(Math.floor((diff % 60000) / 1000));
      coverRoot.querySelectorAll('[data-ledisa-hour]').forEach(function (el) { el.textContent = h; });
      coverRoot.querySelectorAll('[data-ledisa-minute]').forEach(function (el) { el.textContent = m; });
      coverRoot.querySelectorAll('[data-ledisa-seconds]').forEach(function (el) { el.textContent = s; });
    }
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
